import { FC } from 'react';

const FAVICON = 'https://www.lemon8-app.com/favicon.png';

/**
 * TODO apple specific meta
 * @see https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariWebContent/ConfiguringWebApplications/ConfiguringWebApplications.html
 */
export const RootHelmet: FC = () => {
  return (
    <>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
      <link rel="icon" type="image/png" sizes="96x96" href={FAVICON} />
      <link rel="shortcut icon" type="image/png" href={FAVICON} />
      <meta name="referrer" content="origin" />
      <meta name="hostname" content="lemon8-app.com" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#fff" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="msapplication-TileColor" content="#FFF" />
      <meta name="on" content="x-dns-prefetch-control" />
      <meta property="fb:app_id" content="426786581540674" />
    </>
  );
};
